import { SVGProps } from "react";

export default function ArrowUpRightIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, fill = "#20242A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.125 1.875L9.75 1.875C9.84946 1.875 9.94484 1.91451 10.0152 1.98483C10.0855 2.05516 10.125 2.15054 10.125 2.25V7.875C10.125 8.08211 9.95711 8.25 9.75 8.25C9.54289 8.25 9.375 8.08211 9.375 7.875V3.15533L2.51517 10.0152C2.36872 10.1616 2.13128 10.1616 1.98483 10.0152C1.83839 9.86872 1.83839 9.63128 1.98483 9.48483L8.84467 2.625L4.125 2.625C3.91789 2.625 3.75 2.45711 3.75 2.25C3.75 2.04289 3.91789 1.875 4.125 1.875Z"
        fill={fill}
      />
    </svg>
  );
}
